import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi, { UPLOAD_TIMEOUT } from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import Attachment from './Attachment'
import FileInput from 'components/Inputs/FileInput'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import { FaPaperclip } from 'react-icons/fa'
import { Formik } from 'formik'

import {
  Container,
  Row,
  SubTitle,
  InfoText,
  WhiteText,
  FileContainer,
  ErrorContainer
} from './styles'

export default function AttachmentList ({
  attachments = [],
  customerID,
  onDelete: handleDelete,
  onAttachmentAdded: handleAttachmentAdded
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()

  return (
    <Container>
      {AuthService.hasPermission ('customers', 'edit') && (
        <Formik
          initialValues={{ 'attachment': null }}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            try {
              const { attachment } = values
              const formData = new FormData ()

              formData.append ('attachment', attachment)
              formData.append ('customerId', customerID)

              const { data: addedAttachment } = await cutileiApi.post (
                `/businesses/${businessId}/attachments`,
                formData,
                {
                  // Upload/download nao cabe no timeout padrao: rede movel ruim leva mais que 30 s.
                  timeout: UPLOAD_TIMEOUT,
                  headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`
                  }
                }   
              )

              setSubmitting (false)
              resetForm ()
              handleAttachmentAdded (addedAttachment)
            } catch (error) {
              setErrorMessage (getApiErrorMessage (error))
              setSubmitting (false)
              logApiError (error)
            }
          }}
        >
          {({
            values,
            isSubmitting,
            setFieldValue,
            handleSubmit
          }) => (
            <Row>
              <FileInput
                label={values.attachment ? 'Trocar arquivo' : 'Adicionar anexo'}
                onFileSelected={file => setFieldValue ('attachment', file)}
              />
              {values.attachment && (
                <FileContainer>
                  <FaPaperclip size={16} color='#000000' style={{marginRight: -6}}/>
                  <SubTitle>
                    {values.attachment.name}
                  </SubTitle>
                  <SecondaryButton
                    label='Confirmar'
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    loading={isSubmitting}
                    width={100}
                  />
                </FileContainer>
              )}
            </Row>
          )}
        </Formik>
      )}
      {errorMessage && (
        <ErrorContainer>
          <WhiteText>{errorMessage}</WhiteText>
        </ErrorContainer>
      )}
      {attachments.length > 0 ? attachments.map (attachment =>
        <Attachment
          key={attachment.id}
          data={attachment}
          onDelete={handleDelete}
        />
      ) : (
        <InfoText>Este cliente ainda não possui anexos</InfoText>
      )}
    </Container>
  )
}
